import React, { useCallback, useContext } from 'react'

import Button from '../../../../../../../components/Button'
import ItemMediaFields from '../../../../../../ReusableFormFields/MediaFields/ItemMediaFields'

import { transformSingleToCarousel } from './helpers'

import { AD_FORMAT } from '../../../../../../../constants/ads'

import { AdFacebookEditContext } from '../../../AdFacebookEditContextProvider'

import useStyles from './styles'

const SingleMediaForm = ({ formik, adFormat }) => {
  const classes = useStyles()

  const allowSwitchAdToCarousel = adFormat !== AD_FORMAT.singleCustom

  const { campaignObjective } = useContext(AdFacebookEditContext)

  const { values: modifiedAdValues, setValues } = formik

  const switchAdToCarousel = useCallback(() => {
    // transform formik modifiedAdValues to carousel values.
    // for that process single fields values are transformed to carousel item object
    // + newCarouselItem is added and pre-opened for edit
    const valuesWithCarousel = transformSingleToCarousel(modifiedAdValues)

    // set carousel items to formik
    setValues(valuesWithCarousel)
  }, [modifiedAdValues, setValues])

  return (
    <>
      <ItemMediaFields formik={formik} itemPath={'singleMediaItem'} campaignObjective={campaignObjective} />
      {allowSwitchAdToCarousel && (
        <Button className={classes.switchAdTypeBtn} type="button" primary={false} onClick={switchAdToCarousel}>
          Turn this ad into a carousel ad
        </Button>
      )}
    </>
  )
}

export default SingleMediaForm
